import { render, staticRenderFns } from "./InventoryLabel.vue?vue&type=template&id=71476485&scoped=true"
import script from "./InventoryLabel.vue?vue&type=script&lang=js"
export * from "./InventoryLabel.vue?vue&type=script&lang=js"
import style0 from "./InventoryLabel.vue?vue&type=style&index=0&id=71476485&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71476485",
  null
  
)

export default component.exports